import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';

import { SidebarNav } from './SidebarNav';

interface SidebarProps {
  expanded: boolean;
  onToggle: () => void;
}

/** Persistent sidebar, tablet and up. Collapses to an icon rail. */
export function Sidebar({ expanded, onToggle }: SidebarProps) {
  return (
    <nav
      aria-label="Main navigation"
      className="border-bd bg-bg-alt sticky top-[59px] hidden h-[calc(100vh-59px)] flex-none flex-col self-stretch overflow-hidden border-r transition-[width] duration-150 md:flex"
      style={{ width: expanded ? 214 : 56 }}
    >
      <SidebarNav expanded={expanded} />

      <div className="border-bd flex-none border-t p-2">
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={expanded}
          className="text-tx3 hover:bg-elev hover:text-tx flex h-8 w-full items-center gap-2.5 rounded-[7px] px-2"
        >
          <span aria-hidden className="grid w-[22px] flex-none place-items-center">
            {expanded ? <PanelLeftClose size={14} /> : <PanelLeftOpen size={14} />}
          </span>
          {expanded && <span className="text-xs">Collapse</span>}
          <span className="sr-only">
            {expanded ? 'Collapse navigation' : 'Expand navigation'}
          </span>
        </button>
      </div>
    </nav>
  );
}
